import { RelatedCustomizableProductInterface } from '@qlevr/shared/interfaces';
import { Maybe, MetafieldShopify } from '@qlevr/shared/schema';
import isEmpty from 'lodash.isempty';
import { getProductSlug } from './product-slug';
import { productVariantsMapper } from './product-variant';

interface RelatedCustomizableProductProps {
  metafields: Maybe<MetafieldShopify>[];
  locale: string;
}

export function mapRelatedCustomizableProduct({
  metafields,
  locale,
}: RelatedCustomizableProductProps): RelatedCustomizableProductInterface | null {
  if (!metafields || isEmpty(metafields)) {
    return null;
  }

  const metafield = metafields.find((item) => item?.key === 'customizable_product');
  const reference = metafield?.reference;
  if (!reference || reference.__typename !== 'Product') {
    return null;
  }

  const variants = productVariantsMapper(
    reference?.variants?.edges,
    getProductSlug(reference.handle),
    locale,
    reference.title ?? '',
  );

  return {
    key: metafield?.key,
    value: metafield?.value,
    reference: {
      title: reference.title,
      handle: reference.handle,
      variants,
    },
  };
}
